import {
  FormControl, InputLabel,
} from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../../components/CustomSelect';
import { VIEW_MODE } from '../../../../consts/enums';
import STRING_KEYS from '../../../../language/keys';
import { getMonthStr, getYearStr } from '../../../../utils/date';
import { DEFAULT_EXPERIENCE_VALUE } from '../../Constants';
import { renderMonths, renderYears } from '../TalentExperience/TalentExperienceItem/render';
import { style } from './style';

type StartDateProps = {
  companyId: string,
  onDateValueChanged:(select: UpdateValues<string | boolean | null | DateObject>,
    id: string) => void,
  name: string,
  disabled?: boolean,
  dateObj: DateObject | null,
  viewMode: ViewMode
};

export const DateItem = (
  {
    companyId,
    onDateValueChanged,
    name,
    disabled = false,
    dateObj,
    viewMode,
  }: StartDateProps,
): JSX.Element => {
  const { t: translate } = useTranslation();
  const monthStart = getMonthStr(dateObj);
  const yearStart = getYearStr(dateObj);

  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  const viewModeStyle =  isReadOnly ? {
    maxWidth: 120,
  } : {};

  return (
    <>
      <Box style={ style.card.CardContent.boxRow }>
        <Box
          style={ { ...style.card.CardContent.textField.field, ...viewModeStyle } }
        >
          <FormControl fullWidth
            variant={ isReadOnly ? 'standard' : 'outlined' }
            disabled={ disabled }
          >
            <InputLabel id={ name }>
              { translate(STRING_KEYS.LABEL_MONTH) }
            </InputLabel>
            <CustomSelect
              viewMode={ viewMode }
              labelId={ name }
              label={ translate(STRING_KEYS.LABEL_MONTH) }
              id={ name }
              value={ monthStart }
              disabled={ disabled }
              name={ name }
              defaultValue={ monthStart === '' ?
                DEFAULT_EXPERIENCE_VALUE.START_DATE_MONTH : '' }
              onChange={ (e) => {
                const updateValus = {
                  [e.target.name]: {
                    month: Number(e?.target.value),
                    year: +yearStart || '',
                  },
                };
                onDateValueChanged(updateValus, companyId);
              } }
            >
              {renderMonths()}
            </CustomSelect>
          </FormControl>
        </Box>
        <Box style={ style.card.CardContent.textField.field }>
          <FormControl fullWidth
            variant={ isReadOnly ? 'standard' : 'outlined' }
            disabled={ disabled }
          >
            <InputLabel id={ name }>
              { translate(STRING_KEYS.LABEL_YEAR) }
            </InputLabel>
            <CustomSelect
              label={ translate(STRING_KEYS.LABEL_YEAR) }
              placeholder={
                translate(STRING_KEYS.PLACEHOLDER_YEAR)
              }
              viewMode={ viewMode }
              labelId={ name }
              id={ name }
              value={ yearStart }
              disabled={ disabled }
              name={ name }
              defaultValue={ yearStart?.length === 0 ?
                DEFAULT_EXPERIENCE_VALUE.START_DATE_YEAR : '' }
              onChange={ (e) => {
                const updateValus = {
                  [e.target.name]: {
                    month: +monthStart,
                    year: Number(e?.target.value),
                  },
                };
                onDateValueChanged(updateValus, companyId);
              } }
            >
              {renderYears()}
            </CustomSelect>
          </FormControl>
        </Box>
      </Box>
    </>
  );
};

DateItem.defaultProps = {
  disabled: false,
};
